import API from './api';

export const normalizeSearchText = (value) => {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

export const tokenizeSearchText = (value) => {
  const normalized = normalizeSearchText(value);
  if (!normalized) return [];
  return normalized.split(' ').filter(Boolean);
};

const getFormatText = (product) => {
  return (
    product?.prformat?.name ||
    product?.prformat_name ||
    product?.prformat ||
    product?.format_name ||
    product?.format ||
    ''
  );
};

export const buildProductSearchText = (product) => {
  return normalizeSearchText(
    `${product?.code || ''} ${product?.description || ''} ${getFormatText(product)}`
  );
};

export const productMatchesSearchTokens = (product, tokens) => {
  if (!Array.isArray(tokens) || tokens.length === 0) return true;
  const haystack = buildProductSearchText(product);
  return tokens.every((token) => haystack.includes(token));
};

export const searchProducts = async ({ q, supplierId, allProducts, signal }) => {
  const query = String(q || '').trim();

  if (!allProducts) {
    if (!supplierId) return [];
    const response = await API.post(
      'product/getProductsBySupplier/',
      { supplier_id: Number(supplierId) },
      { signal }
    );
    return Array.isArray(response?.data) ? response.data : [];
  }

  if (query.length < 2) return [];

  const response = await API.get('product/', {
    params: {
      search: query,
      limit: 5,
      active: true,
    },
    signal,
  });
  const items = Array.isArray(response?.data) ? response.data : [];
  return items.slice(0, 5);
};

